import { faGear, faUserGroupSimple } from '@fortawesome/pro-regular-svg-icons';

import { PAGE_CONFIGURATIONS, PAGE_ROUTES } from '@cloud-wave/neon-common-lib/app';

import { adminOnly } from '../../routes/userRoleCombinations';

export const ADMIN_NAV_OPTIONS = {
  icon: faGear,
  name: 'Settings',
  allowedRoles: adminOnly,
  pageHasSubMenu: true,
  link: PAGE_ROUTES.USER_SETTINGS,
  items: [
    {
      link: PAGE_ROUTES.USER_SETTINGS,
      icon: faUserGroupSimple,
      name: PAGE_CONFIGURATIONS[PAGE_ROUTES.USER_SETTINGS].title,
      activeClassName: 'nav-active',
    },
  ],
};
